// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.usuarios-add-wrapper {
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/app/usuario/usuario-add/usuario-add.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ","sourcesContent":[".usuarios-add-wrapper {\n    margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
